import { Table } from "antd";
import * as React from "react";

import { CardController } from 'src/app/shared/card.controller';
import { BooleanView } from "src/core/ui/boolean.view";

export interface PermissionSummary extends PermissionItem {
	isChecked: boolean;
	children: Array<PermissionSummary>;
}

interface RolePermissionListViewProps {
	data: Array<PermissionSummary>;
	mode: ControlMode;
	onRoleChange: (permissionId: number, isChecked: boolean, reload?: boolean) => void;
}

const rolePermissionListView: React.SFC<RolePermissionListViewProps> = (props) => {
	const columns: Array<{}> = [
		{
			key: "description",
			title: "Name",
			dataIndex: "description",
			render: (text: any, record: PermissionSummary) => text || record.name,
		},
		{
			key: "isChecked",
			title: "",
			dataIndex: "isChecked",
			width: 100,
			render: (text: any, record: PermissionSummary, index: number) => {
				const onChanged = (checked) => props.onRoleChange(record.id, checked);

				return (
					<BooleanView
						mode={props.mode}
						value={record.isChecked}
						onChanged={onChanged}
						label={null}
						size="small"
					/>
				);
			}
		},
	];

	return (
		<CardController
			title="Permissions"
			icon="fa fa-shield"
			className="card-borderless"
			mode={props.mode}
		>
			<Table size="small" columns={columns} dataSource={props.data ? props.data : []} rowKey="id" />
		</CardController>
	);
}

export default rolePermissionListView;



// WEBPACK FOOTER //
// ./src/app/general/roles/form/parts/role-permission-list.view.tsx